/* Copyright (c) 2017 Backpack Health LLC */
import * as _ from 'lodash';

class ColorThemeModel {

  static getColorTheme(colorThemeId, colorThemes) {
    const foundThemes = colorThemes.filter((c) => c.id === colorThemeId);
    return foundThemes.length > 0 ? new ColorThemeModel(foundThemes[0]) : new ColorThemeModel({});
  }

  constructor(data) {
    this.data = _.assign({}, {
      base_color: {
        r: 0, g: 0, b: 0, a: 1,
      },
      accent_color: {
        r: 0, g: 0, b: 0, a: 1,
      },
      highlight_color: {
        r: 0, g: 0, b: 0, a: 1,
      },
    }, data);
  }

  baseColor() {
    return this.data.base_color;
  }

  baseColorCss(forceAlpha) {
    const color = this.data.base_color;
    const alpha = forceAlpha || color.a;
    return `rgba(${color.r},${color.g},${color.b},${alpha})`;
  }

  accentColorCss(forceAlpha) {
    const color = this.data.accent_color;
    const alpha = forceAlpha || color.a;
    return `rgba(${color.r},${color.g},${color.b},${alpha})`;
  }

  highlightColorCss(forceAlpha) {
    const color = this.data.highlight_color;
    const alpha = forceAlpha || color.a;
    return `rgba(${color.r},${color.g},${color.b},${alpha})`;
  }
}

export default ColorThemeModel;
